import React from "react";
import { PhaseDictionary } from "../../Enum";

interface PhaseSelectorProps {
  selectedPhases: number[];
  onChange: (phases: number[]) => void;
  error?: string;
}

const PhaseSelector: React.FC<PhaseSelectorProps> = ({
  selectedPhases,
  onChange,
  error,
}) => {
  const phases = Object.entries(PhaseDictionary).map(([key, display]) => ({
    id: parseInt(key, 10),
    display,
  }));

  const handleTogglePhase = (phaseId: number) => {
    if (selectedPhases.includes(phaseId)) {
      onChange(selectedPhases.filter((id) => id !== phaseId));
    } else {
      onChange([...selectedPhases, phaseId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedPhases.length === phases.length) {
      onChange([]);
    } else {
      onChange(phases.map((p) => p.id));
    }
  };

  const allSelected = selectedPhases.length === phases.length;

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="block text-sm font-medium text-gray-700">
          Applicable Phases
        </label>
        <button
          type="button"
          onClick={handleSelectAll}
          className="text-xs text-blue-600 hover:text-blue-800 font-medium"
        >
          {allSelected ? "Deselect All" : "Select All"}
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 p-4 border border-gray-300 rounded-lg bg-gray-50">
        {phases.map((phase) => (
          <label
            key={phase.id}
            className={`flex items-center p-2.5 rounded-md cursor-pointer transition-colors ${
              selectedPhases.includes(phase.id)
                ? "bg-blue-100 border-blue-500 border-2"
                : "bg-white border-gray-300 border hover:bg-gray-100"
            }`}
          >
            <input
              type="checkbox"
              checked={selectedPhases.includes(phase.id)}
              onChange={() => handleTogglePhase(phase.id)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-2 text-sm font-medium text-gray-700">
              Phase {phase.display}
            </span>
          </label>
        ))}
      </div>

      {selectedPhases.length === 0 && (
        <p className="text-xs text-gray-500 mt-2">
          No phases selected - rule will apply to all phases
        </p>
      )}

      {error && (
        <p className="text-red-500 text-xs mt-2">{error}</p>
      )}
    </div>
  );
};

export default PhaseSelector;